export default __webpack_public_path__ + "static/media/stripe.80afaafe.png";